import api from './api';

export const contactAPI = {
  getAllContacts: async (params: { page?: number; limit?: number; search?: string }) => {
    const response = await api.get('/contactform/getall', { params });
    return response.data;
  },
  deleteContact: async (id: string) => {
    const response = await api.delete(`/contactform/delete/${id}`);
    return response.data;
  },
};